import { makeUseAxiosQuery } from '@nordvpn/teams.core/lib/hooks/react-query/useAxiosQuery';
import { defaultOptions } from './reactQuery';
export var useAxiosQuery = makeUseAxiosQuery(defaultOptions);
